import ApeironComponent from '@/components/commons/apeiron-component.model';
import { ActividadRetribucion, MenuGenerico, ResultadosRetribucion } from '@/shared/model/ars/ars.model';
import CatalogosArs from '@/shared/model/ars/catalogos-ars.factory';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { maxLength, minValue, required } from 'vuelidate/lib/validators';

const validations = function () {
  return {
    resultadosForm: {
      productosGenerados: { required },
      resultadosAlcanzados: { required, maxLength: maxLength(500) },
      evidenciasDisponibles: { required },
    },
  };
};
@Component({
  validations,
})
export default class ActividadResultadosArsComponent extends ApeironComponent {
  @Prop({ required: true })
  public readonly solucion!: Solucion;

  @Prop({ required: true })
  public readonly solicitud!: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  public resultadosForm: ResultadosRetribucion = new ResultadosRetribucion(); // se pobla con los datos del property

  public opcionesProductosGenerados: Array<MenuGenerico> = [];
  public opcionesEvidenciasDisponibles: Array<MenuGenerico> = [];

  public mounted(): void {
    this.opcionesProductosGenerados =
      CatalogosArs.obtenerProductosGenerados().map(producto => new MenuGenerico(producto.descripcion, producto)) ?? [];
    this.opcionesEvidenciasDisponibles =
      CatalogosArs.obtenerEvidencias().map(evidencia => new MenuGenerico(evidencia.descripcion, evidencia)) ?? [];
    if (this.solicitud && this.solicitud.resultadosRetribucion) {
      this.resultadosForm = ResultadosRetribucion.fromObject(this.solicitud.resultadosRetribucion);
    }
  }

  public guardarResultados(): void {
    this.$emit('submit', { resultadosRetribucion: this.resultadosForm });
  }

  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }

  get desactivarBoton(): boolean {
    return this.$v.$invalid;
  }
}
